import { ConfigType } from "../utils/requestAPI";

export type UtilityCategoryType = {
  _id?: string;
  avatar?: string;
  title?: string | string[];
};

export type UtilityProvidersType = {
  name: string;
  avatar?: string;
  category: string[];
  webSite: string;
  mprn: string;
  providerUrl?: string;
};

export type AmenityType = {
  _id?: string;
  title: string;
  avatar?: string;
  icon?: string;
  amenityUrl?: string;
  order?: number;
};

export type EmployerType = {
  _id?: string;
  avatar?: string;
  name: string;
  country: string;
  address: string;
  employerUrl?: string;
};

export type paginationType = {
  limit?: number;
  total?: number;
  totalPages?: number;
  currentPage?: number;
  page?: number;
  search?: string;
};

const settings = {
  // getUtilityCategory: (params?: paginationType): ConfigType => {
  //   return {
  //     method: "get",
  //     url: "utility-categories",
  //     // params,
  //   };
  // },
  // addUtilityCategory: (data: UtilityCategoryType): ConfigType => {
  //   return {
  //     method: "post",
  //     url: "admins/utility-category",
  //     data,
  //   };
  // },

  // updateUtilityCategory: (
  //   id: string,
  //   data: UtilityCategoryType
  // ): ConfigType => {
  //   return {
  //     method: "put",
  //     url: `admins/utility-category/${id}`,
  //     data,
  //   };
  // },

  // deleteUtilityCategory: (id: string): ConfigType => {
  //   return {
  //     method: "delete",
  //     url: `admins/utility-category/${id}`,
  //   };
  // },
  getUtilityProviders: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "admins/utility-providers",
      params,
    };
  },

  getSingleUtilityProviders: (id: string): ConfigType => {
    return {
      method: "get",
      url: `admins/utility-provider/${id}`,
    };
  },

  addUtilityProvider: (data: UtilityProvidersType): ConfigType => {
    return {
      method: "post",
      url: "admins/utility-provider",
      data,
    };
  },
  updateUtilityProvider: (
    id: string,
    data: UtilityProvidersType,
  ): ConfigType => {
    return {
      method: "put",
      url: `admins/utility-provider/${id}`,
      data,
    };
  },

  getRefImageCategory: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "reference-categories",
      params,
    };
  },
  deleteRefImageCategory: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `reference-categories/${id}`,
    };
  },
  addRefImageCategory: (data: { title: string }): ConfigType => {
    return {
      method: "post",
      url: "reference-categories",
      data,
    };
  },
  getAmenities: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "amenities",
      params,
    };
  },
  getAmenitiesIcon: (): ConfigType => {
    return {
      method: "get",
      url: "amenities-icon",
    };
  },
  addAmenityIcon: (data: { icon: string }): ConfigType => {
    return {
      method: "post",
      url: "amenities-icon",
      data,
    };
  },
  deleteAmenityIcon: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `amenities-icon/${id}`,
    };
  },

  addAmenity: (data: AmenityType): ConfigType => {
    return {
      method: "post",
      url: "amenities",
      data,
    };
  },

  updateAmenity: (id: string, data: AmenityType): ConfigType => {
    return {
      method: "put",
      url: `amenities/${id}`,
      data,
    };
  },
  deleteAmenity: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `amenities/${id}`,
    };
  },

  addEmployer: (data: EmployerType): ConfigType => {
    return {
      method: "post",
      url: "admins/employer",
      data,
    };
  },

  getSingleEmployer: (id: string): ConfigType => {
    return {
      method: "get",
      url: `employer/${id}`,
    };
  },
  getSingleContract: (id: string): ConfigType => {
    return {
      method: "get",
      url: `/contracts/${id}`,
    };
  },

  getEmployer: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "employer",
      params,
    };
  },

  updateEmployer: (id: string, data: EmployerType): ConfigType => {
    return {
      method: "put",
      url: `admins/employer/${id}`,
      data,
    };
  },

  deleteEmployer: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `admins/employer/${id}`,
    };
  },
  getInventoryIcons: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "inventory-categories-icons",
      params,
    };
  },
  addInventoryIcons: (data: { icon: string | string[] }): ConfigType => {
    return {
      method: "post",
      url: "inventory-categories-icons",
      data,
    };
  },
  deleteInventoryIcons: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `inventory-categories-icons/${id}`,
    };
  },
  deleteRulesCategory: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `rule-categories/${id}`,
    };
  },
  addRulesCategory: (data: { title: string; icon: string }): ConfigType => {
    return {
      method: "post",
      url: `rule-categories`,
      data,
    };
  },
  updatRulesCategory: ({
    data,
    id,
  }: {
    data: { title: string; icon: string };
    id: string;
  }): ConfigType => {
    return {
      method: "put",
      url: `rule-categories/${id}`,
      data,
    };
  },
  getRulesCategory: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "rule-categories",
      params,
    };
  },
  getPolicyCategory: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "policy-categories",
      params,
    };
  },

  addPolicyCategory: (data: { title: string; icon: string }): ConfigType => {
    return {
      method: "post",
      url: "policy-categories",
      data,
    };
  },

  updatePolicyCategory: ({
    data,
    id,
  }: {
    data: { title: string; icon: string };
    id: string;
  }): ConfigType => {
    return {
      method: "put",
      url: `policy-categories/${id}`,
      data,
    };
  },

  deletePolicyCategory: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `policy-categories/${id}`,
    };
  },

  // Utility Category API Functions
  getUtilityCategories: (params?: paginationType): ConfigType => {
    return {
      method: "get",
      url: "utility-categories",
      params,
    };
  },

  getUtilityCategory: (id: string): ConfigType => {
    return {
      method: "get",
      url: `utility-categories/${id}`,
    };
  },

  addUtilityCategory: (data: {
    icon: string;
    category: string;
    title: string[]; // Unique titles for subcategories
  }): ConfigType => {
    return {
      method: "post",
      url: "utility-categories",
      data,
    };
  },

  updateUtilityCategory: ({
    data,
    id,
  }: {
    data: {
      icon?: string;
      category: string;
      title: string[];
    };
    id: string;
  }): ConfigType => {
    return {
      method: "put",
      url: `utility-categories/${id}`,
      data,
    };
  },

  deleteUtilityCategory: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `utility-categories/${id}`,
    };
  },
  getGlobalSettingsPromote: (): ConfigType => {
    return {
      method: "get",
      url: `global-settings`,
    };
  },
  addUpdateTaxPercentage: (data: { taxPercentage: number }): ConfigType => {
    return {
      method: "post",
      url: `global-settings/tax-percentage`,
      data,
    };
  },
  addUpdateVatPercentage: (data: { vatPercentage: number }): ConfigType => {
    return {
      method: "post",
      url: `global-settings/vat-percentage`,
      data,
    };
  },
  getGlobalSettingsPlatformFee: (): ConfigType => {
    return {
      method: "get",
      url: `global-settings`,
    };
  },
  addGlobalSettingPromote: (data: {
    promoteProperty: {
      perDayRate: number;
      name: string;
      description: string[];
      currency: string;
      weeklyDiscountRate: number;
      monthlyDiscountRate: number;
      viewCountInterval: number;
    };
  }): ConfigType => {
    return {
      method: "post",
      url: "global-settings/promote-property",
      data,
    };
  },
  addGlobalSettingPlatformFee: (data: {
    percentageFee: number;
    flatFee: number;
    currency: string;
  }): ConfigType => {
    return {
      method: "post",
      url: "global-settings/platform-fee",
      data,
    };
  },
  addGlobalSettingStripeFee: (data: {
    percentageFee: number;
    flatFee: number;
    currency: string;
    paymentMethod?: string;
  }): ConfigType => {
    return {
      method: "post",
      url: "global-settings/stripe-fee",
      data,
    };
  },
  removeGlobalSettingStripeFee: (data: {
    paymentMethod?: string;
  }): ConfigType => {
    return {
      method: "delete",
      url: `global-settings/stripe-fee/${data.paymentMethod}`,
    };
  },
  getRatingCategory: (): ConfigType => {
    return {
      method: "get",
      url: "rating-categories",
    };
  },
  addRatingCategory: (data: {
    ratedResource: string;
    categories: string[];
  }): ConfigType => {
    return {
      method: "post",
      url: "rating-categories",
      data,
    };
  },
  updateRatingCategory: (
    data: {
      ratedResource: string;
      categories: string[];
    },
    id: string,
  ): ConfigType => {
    return {
      method: "put",
      url: `rating-categories/${id}`,
      data,
    };
  },
  addVerificationStripeFee: (data: {
    verification: {
      percentageFee: number;
      flatFee: number;
      currency: string;
    };
    lookup: {
      percentageFee: number;
      flatFee: number;
      currency: string;
    };
    flatFee: number;
  }): ConfigType => {
    return {
      method: "post",
      url: "global-settings/verification-fee",
      data,
    };
  },

  deleteGlobalSettings: (id: string): ConfigType => {
    return {
      method: "delete",
      url: `global-settings/${id}`,
    };
  },
  getS3PrivateUrl: (key: string): ConfigType => {
    return {
      method: "post",
      url: "/common/private-signed-url",
      data: { key },
    };
  },
};

export default settings;
